"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UnfoldDictionaryToAttributesPrebind = (function () {
    function UnfoldDictionaryToAttributesPrebind() {
        this.name = "unfoldDictionaryToAttributesPrebind";
    }
    UnfoldDictionaryToAttributesPrebind.prototype.getPrebind = function (args) {
        return function (rawDictionary, element) {
            var parsedDictionary = JSON.parse(rawDictionary);
            Object.keys(parsedDictionary).forEach(function (key) {
                var translatedField = args.fieldsHandler.toCoveo(key);
                var dataKey = "field" + translatedField.charAt(0).toUpperCase() + translatedField.slice(1);
                element.dataset[dataKey] = parsedDictionary[key];
            });
            return rawDictionary;
        };
    };
    return UnfoldDictionaryToAttributesPrebind;
}());
exports.UnfoldDictionaryToAttributesPrebind = UnfoldDictionaryToAttributesPrebind;



//////////////////
// WEBPACK FOOTER
// ./src/resolvers/prebinding/prebindHelpers/UnfoldDictionaryToAttributes.ts
// module id = 44
// module chunks = 13 14